"use client"
import * as React from "react"
import { TrendingUp } from "lucide-react"
import { Bar, BarChart, CartesianGrid, XAxis } from "recharts"
import { addDays, subDays, format, subMonths, addMonths, startOfToday, endOfToday } from "date-fns";
import { ShadStackedBarChart } from "../ShadStackedBarChart";

// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardFooter,
//   CardHeader,
//   CardTitle,
// } from "../../ui/Card"
// import {
//   ChartConfig,
//   ChartContainer,
//   ChartLegend,
//   ChartLegendContent,
//   ChartTooltip,
//   ChartTooltipContent,
// } from "../../ui/Chart"
// import {
//     Select,
//     SelectContent,
//     SelectItem,
//     SelectTrigger,
//     SelectValue,
//   } from "../../ui/Select"
// import {  } from "./DateRangePicker"
// import { DatePickerWithRange } from "./DateRangePicker"
// import { DatePickerDemo } from "./DateRangePicker"
// import { DatePickerWithRange } from "./DateRangePicker"
// import { DatePickerWithRange } from "./ShadDateRangePicker"
// import { MyDatePicker } from "./dayPicker"
import { el } from "date-fns/locale";
import { use } from "react";


const chartConfig = {
    desktop: {
        label: "אחד העם",
        color: "hsl(var(--chart-1))",
    },
    mobile: {
        label: "סן מרטין",
        color: "hsl(var(--chart-2))",
    },
    tablet: {
        label: "שדרות צבי",
        color: "hsl(var(--chart-3))",
    },
    laptop: {
        label: "פרץ ברנשטיין",
        color: "hsl(var(--chart-4))",
    },
    ledtv: {
        label: "חניוני לב הפארק",
        color: "hsl(var(--chart-5))",
    },
    lcdtv: {
        label: "שחר",
        color: "hsl(var(--chart-6))",
    },
    oledtv: {
        label: "חן",
        color: "hsl(var(--chart-7))",
    },
}

const deviceTypes = Object.keys(chartConfig);

const PRESETS = [
    { label: "שבוע",     days: 7  },
    { label: "14 ימים",  days: 14 },
    { label: "חודש",     days: 30 },
    { label: "3 חודשים", days: 90 },
];

export function NationalParkBarChart({ deviceNames, dataByDuration, updateTimeBasedData }) {
    console.log(dataByDuration, "chartDataa");

    const today = startOfToday();
    const endToday = endOfToday();
    const [calenderStartDate, setCalenderStartDate] = React.useState(subDays(startOfToday(), 7));
    const [calenderEndDate, setCalenderEndDate] = React.useState(endOfToday);
    const [calenderComponentDisabled, setCalenderComponentDisabled] = React.useState(false);
    const [activeDays, setActiveDays] = React.useState(null);

    const [selectedLocation, setSelectedLocation] = React.useState("all");

    React.useEffect(() => {
        if (calenderComponentDisabled) {
          setCalenderComponentDisabled(false);
        }
    }, [dataByDuration]);

    React.useEffect(() => {
        console.log( "dateChngod");
        updateTimeBasedData({
            from: calenderStartDate,
            to: calenderEndDate
          });
    }, []);

    const handleDateSelect = (identifier, date) => {
        if (!date) {
          console.error('Invalid date');
          return;
        }
        setActiveDays(null); // clear preset highlight when user manually picks
        if (identifier === "start") {
          setCalenderStartDate(date);
        } else if (identifier === "end") {
          setCalenderEndDate(date);
        }
    };

    const handlePreset = (days) => {
        const from = subDays(startOfToday(), days);
        const to = endOfToday();
        setActiveDays(days);
        setCalenderStartDate(from);
        setCalenderEndDate(to);
        setCalenderComponentDisabled(true);
        updateTimeBasedData({ from, to });
    };

    let currentChartConfig = { ...chartConfig };
    let currentDeviceTypes = [...deviceTypes];
    let chartData = [];

    if (selectedLocation === "all") {
        const result = dataByDuration.map((item, i) => {
            const itemResult = item?.result || [];
            const reduceResult = itemResult.reduce((acc, curr) => {
                const dateOnly = new Date(curr.date).toLocaleDateString("sv-SE", { timeZone: "Asia/Jerusalem" });
                acc[dateOnly] = (acc[dateOnly] || 0) + curr.entering;
                return acc;
            }, {});
            return { [deviceNames[i]]: reduceResult }
        });

        const formattedResult = result.map((resultItem, i) => {
            const targetObj = resultItem[deviceNames[i]] || {};
            const locationFormattedResult = Object.entries(targetObj).map(([date, enteringSum]) => ({
                date,
                enteringSum
            }));
            return locationFormattedResult;
        });

        const allDates = Array.from(
            new Set(formattedResult.flatMap((deviceData) => deviceData.map((d) => d.date)))
        ).sort();

        allDates.forEach((dateKey) => {
            let entry = { month: new Date(dateKey).toLocaleString('he-IS', { day: 'numeric', month: 'short', weekday: 'short' }) };
            formattedResult.forEach((deviceData, deviceIndex) => {
                const match = deviceData.find((d) => d.date === dateKey);
                entry[deviceTypes[deviceIndex]] = match ? match.enteringSum : 0;
            });
            chartData.push(entry);
        });

    } else {
        // SubLot drill-down logic
        const locationIndex = deviceTypes.indexOf(selectedLocation);
        const itemResult = dataByDuration[locationIndex]?.result || [];
        
        const dateMap = {}; 
        const foundSubLots = new Set();

        itemResult.forEach(curr => {
            const dateOnly = new Date(curr.date).toLocaleDateString("sv-SE", { timeZone: "Asia/Jerusalem" });
            if (!dateMap[dateOnly]) dateMap[dateOnly] = {};
            
            if (curr.subLots && Object.keys(curr.subLots).length > 0) {
                let subLotTotal = 0;
                Object.entries(curr.subLots).forEach(([subLotName, subLotData]) => {
                    foundSubLots.add(subLotName);
                    dateMap[dateOnly][subLotName] = (dateMap[dateOnly][subLotName] || 0) + (subLotData.entering || 0);
                    subLotTotal += (subLotData.entering || 0);
                });
                
                // Add any remaining entries to 'default' (main gates)
                if ((curr.entering || 0) > subLotTotal) {
                    foundSubLots.add("default");
                    dateMap[dateOnly]["default"] = (dateMap[dateOnly]["default"] || 0) + ((curr.entering || 0) - subLotTotal);
                }
            } else {
                if ((curr.entering || 0) > 0) {
                    foundSubLots.add("default");
                    dateMap[dateOnly]["default"] = (dateMap[dateOnly]["default"] || 0) + (curr.entering || 0);
                }
            }
        });

        const allDates = Object.keys(dateMap).sort();
        currentDeviceTypes = Array.from(foundSubLots);
        
        currentChartConfig = {};
        const colors = [
            "hsl(var(--chart-1))", "hsl(var(--chart-2))", "hsl(var(--chart-3))", 
            "hsl(var(--chart-4))", "hsl(var(--chart-5))", "hsl(var(--chart-6))", "hsl(var(--chart-7))"
        ];
        const subLotTranslations = {
            "horse_farm": "חוות סוסים",
            "volleyball": "כדורעף",
            "default": "ראשי"
        };
        currentDeviceTypes.forEach((subLot, idx) => {
            currentChartConfig[subLot] = {
                label: subLotTranslations[subLot] || subLot,
                color: colors[idx % colors.length]
            };
        });

        allDates.forEach((dateKey) => {
            let entry = { month: new Date(dateKey).toLocaleString('he-IS', { day: 'numeric', month: 'short', weekday: 'short' }) };
            currentDeviceTypes.forEach(subLot => {
                entry[subLot] = dateMap[dateKey][subLot] || 0;
            });
            chartData.push(entry);
        });
    }

    const dataWithTotal = chartData.map((item) => ({
        ...item,
        total: currentDeviceTypes.reduce((acc, curr) => (item[curr] || 0) + acc, 0)
    }));

    const handleDateSubmit = () => {
        setCalenderComponentDisabled(true);
        updateTimeBasedData({
          from: calenderStartDate,
          to: calenderEndDate
        })
    }

    const presetButtons = PRESETS.map(({ label, days }) => (
        <button
            key={days}
            disabled={calenderComponentDisabled}
            onClick={() => handlePreset(days)}
            style={{
                padding: "3px 11px",
                borderRadius: "9999px",
                fontSize: "12px",
                fontWeight: activeDays === days ? "700" : "400",
                cursor: calenderComponentDisabled ? "not-allowed" : "pointer",
                border: "1.5px solid",
                borderColor: activeDays === days ? "#6366f1" : "#d1d5db",
                background: activeDays === days ? "#eef2ff" : "transparent",
                color: activeDays === days ? "#4338ca" : "#374151",
                transition: "all 0.15s ease",
                opacity: calenderComponentDisabled ? 0.6 : 1,
            }}
        >
            {label}
        </button>
    ));

    const filterElement = (
        <select
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
            style={{
                padding: "3px 11px",
                borderRadius: "9999px",
                fontSize: "12px",
                border: "1.5px solid #d1d5db",
                background: "white",
                color: "#374151",
                cursor: "pointer",
                outline: "none"
            }}
        >
            <option value="all">כל החניונים (סה״כ)</option>
            {deviceTypes.map((key) => (
                <option key={key} value={key}>{chartConfig[key].label}</option>
            ))}
        </select>
    );

    return (
        <ShadStackedBarChart
            calenderStartDate={calenderStartDate}
            calenderEndDate={calenderEndDate}
            handleDateSelect={handleDateSelect}
            cardTitle={selectedLocation === "all" ? "סך כל הכניסות לחניוני הפארק הלאומי" : `כניסות בחניון: ${chartConfig[selectedLocation].label}`}
            cardDescription={selectedLocation === "all" ? "כניסות לפי חניון" : "פילוח כניסות לפי מתחם/תת-חניון"}
            chartConfig={currentChartConfig}
            chartData={dataWithTotal}
            deviceTypes={currentDeviceTypes}
            showTotal={true}
            calenderComponentDisabled={calenderComponentDisabled}
            handleDateSubmit={handleDateSubmit}
            buttonText={"הצג"}
            presetButtons={presetButtons}
            filterElement={filterElement}
        />
    )
}
